export default "__VITE_ASSET__XpH666Dl__";